import React, { useMemo } from 'react';
import { ICONS } from '../StaticForm/StaticForm';
import { useLabelIcons } from '../Widgets/utils/getLabelIcons';
import RequiredIndicator from '../RequiredIndicator/RequiredIndicator';
var formContext = {
  icons: ICONS
};
export default function LabelIcons(_ref) {
  var id = _ref.id,
    icons = _ref.icons;
  var uiSchema = useMemo(function () {
    return {
      'ui:options': {
        icons: icons
      }
    };
  }, [icons]);
  var _useLabelIcons = useLabelIcons(id, formContext, uiSchema),
    labelIcons = _useLabelIcons.labelIcons;
  var required = icons && icons.indexOf('REQUIRED') !== -1;
  return /*#__PURE__*/React.createElement("span", {
    id: id
  }, required && /*#__PURE__*/React.createElement(RequiredIndicator, {
    required: true,
    id: "id--REQUIRED"
  }), labelIcons);
}